import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { LocalStorage } from "../../utils";

const ProtectedRoute = () => {
	const accessToken = LocalStorage.get("accessToken");
	const user = JSON.parse(LocalStorage.get("user"));

	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	const checkTokenValidity = () => {
		if (accessToken && user?._id) {
			setIsAuthenticated(true);
		} else {
			setIsAuthenticated(false);
			window.location.href = "/";
		}

		setIsLoading(false);
	};

	useEffect(() => {
		checkTokenValidity();
	}, []);

	if (isLoading) {
		return <div>Loading...</div>;
	}

	return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
